export function formatBallot(ballot) {
  return ballot.filter(row => row.size !== 0).map(row => {
    return Array.from(row).sort().join(", ")
  }).join("\n")
}
